import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular//http';
import { User } from '../_models/index';
import 'rxjs/add/operator/toPromise';
import { AuthHttp } from 'angular2-jwt';
import { environment } from '../../environments/environment';

@Injectable()

export class RestManageUserServices {

    backendUrl: any;
    TOKEN: any;
    headers: any;
    options: any;
    secret: any;

    api = "/restmanageuser/"

    constructor(private http: AuthHttp) {
        // this.backendUrl = environment.url;
         this.backendUrl=window.location.origin
        this.backendUrl+="/apis"
        this.secret = environment.secret;
    }

     getallRestaurantUsersDataByFbUID(id:any) {
        return this.http.get(`${this.backendUrl}${this.api}all-restusersdata-fbuidblank/${id}` , this.jwt_new()).map((response: Response) => response.json());
    }

     deleteuserById(data) {
        return this.http.post(`${this.backendUrl}${this.api}delete-user/` ,data, this.jwt_new()).map((response: Response) => response.json());
    }

    getAllTimezoneData() {
        return this.http.get(`${this.backendUrl}${this.api}getall-timezone-data/` , this.jwt_new()).map((response: Response) => response.json());
    }

    // getRoleIdByPlanMapping(id:any,user_id:any) {
    //     return this.http.get(`${this.backendUrl}${this.api}get-roleId-plan-mapping/${id}/${user_id}` , this.jwt_new()).map((response: Response) => response.json());
    // }

    getRestaurantUsersDataByUserId(id:any,user_id:any) {
        return this.http.get(`${this.backendUrl}${this.api}get-restdataby-userid/${id}/${user_id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    AddUpdateUsersData(data) {
        return this.http.post(`${this.backendUrl}${this.api}add-update-user-data/` ,data, this.jwt_new()).map((response: Response) => response.json());
    }

    AddUpdateAccessData(data) {
        return this.http.post(`${this.backendUrl}${this.api}add-update-access-data/` ,data, this.jwt_new()).map((response: Response) => response.json());
    }

    getAllBranchesByRestId(id:any) {
        return this.http.get(`${this.backendUrl}${this.api}get-allbranches-restid/${id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    private jwt_new() {
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.headers.append('Authorization', this.TOKEN)
        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }

    private jwt() {
        // create authorization header with jwt token
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        let headers = new Headers({ 'Authorization': this.TOKEN });
        return new RequestOptions({ headers: headers });
    }
}


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_services/restmanageusers.service.ts